import { ScrollStrategyOptions } from '@angular/cdk/overlay';
import { Injectable, inject } from '@angular/core';
import { DynamicModalService } from '../dynamic-modal/dynamic-modal.service';
import { DynamicModalRef } from '../dynamic-modal/dynamic-modal.types';
import { LoadingSpinnerComponent } from './loading-spinner.component';

/** v8 ignore: Angular decorator metadata creates false-positive uncovered branches in v8 coverage. */
/* v8 ignore start */
@Injectable({ providedIn: 'root' })
export class LoadingSpinnerService {
  /* v8 ignore stop */
  readonly #scrollStrategyOptions = inject(ScrollStrategyOptions);
  readonly #dynamicModalService = inject(DynamicModalService);

  #dialogRef: DynamicModalRef<LoadingSpinnerComponent> | null = null;

  /** Shows the loading spinner overlay. */
  public show(): void {
    this.#dialogRef = this.#dynamicModalService.open(LoadingSpinnerComponent, {
      panelClass: 'modal-transparent-panel',
      disableClose: true,
      scrollStrategy: this.#scrollStrategyOptions.noop(),
      closeOnNavigation: false
    });
  }

  /** Hides the loading spinner overlay. */
  public hide(): void {
    if (this.#dialogRef?.close) {
      this.#dialogRef.close();
      this.#dialogRef = null;
    }
  }
}
